module.exports = {"411327001":"赵河街道","411327002":"潘河街道","411327100":"赊店镇","411327101":"桥头镇","411327103":"饶良镇","411327104":"兴隆镇","411327105":"晋庄镇","411327106":"李店镇","411327107":"苗店镇","411327108":"郝寨镇","411327109":"朱集镇","411327110":"下洼镇","411327111":"太和镇","411327112":"大冯营镇","411327113":"陌陂镇","411327313":"唐庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411327.json
// module id = 1504
// module chunks = 0